// Grid.js
import { useNavigate } from "react-router-dom";
import "./Grid.css";

const Grid = () => {
  const navigate = useNavigate();

  const handleButtonClick = (id) => {
    if (id === 1) navigate("/StudentGrid");
    if (id === 2) navigate("/HotelGrid");
    if (id === 3) navigate("/LodgeGrid");
    if (id === 4) navigate("/CardGrid");
  };

  const buttons = [
    { id: 1, label: "Student Accommodation", desc: "Affordable and convenient.", imageUrl: "pexels-yankrukov-8199169.jpg" },
    { id: 2, label: "Hotel", desc: "Luxury stays with premium service.", imageUrl: "pexels-bohlemedia-2288281.jpg" },
    { id: 3, label: "Lodge", desc: "Comfortable lodges in nature.", imageUrl: "Maungani.jpg" },
    { id: 4, label: "Apartments / Flats", desc: "Modern living for families.", imageUrl: "Apartments.png" },
  ];

  return (
    <div className="Grid-Background">
      <div className="button-grid">
        {buttons.map((button) => (
          <div key={button.id} className="grid-card">
            <div className="grid-image" style={{ backgroundImage: `url(${button.imageUrl})` }}>
              <div className="overlay">
                <h3 className="button-label">{button.label}</h3>
                <p className="button-desc">{button.desc}</p>
                <button className="apply-btn" onClick={() => handleButtonClick(button.id)}>
                  Apply Now
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Grid;
